module.exports = __webpack_public_path__ + "media/img/materialowa@2x-434f9a47.png";